import { apiFetchBaseQuery } from "@/redux/apiFetchBaseQuery";
import { GetMeResponse, SessionUser } from "@/types/AuthUser";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { createApi } from "@reduxjs/toolkit/query/react";
import persistReducer from "redux-persist/es/persistReducer";
import storage from "redux-persist/es/storage";

const initialState: SessionUser = {
	logged: false,
	show_promotion_modal: false,
	agency_promotion_agency_id: 0,
	agency_promotion_amount: "0.00",
	agency_promotion_end_date: "",
	order_search_default: null,
	id: "",
	email: "",
	username: "",
	company_name: "",
	first_name: "",
	last_name: "",
	phone: null,
	campaign_end_default_days: "",
	address: null,
	city: null,
	state: null,
	postal: null,
	status: "",
	type: "",
	is_admin: "N",
	is_db_count: "N",
	is_order_track: "N",
	is_smallbiz_package: "N",
	is_order_create: "N",
	agency_id: "",
	is_staff: "N",
	is_reporting: "N",
	is_openpixel: "N",
	is_tester: "N",
	is_support: "N",
	is_agent: "N",
	is_agency_files: "N",
	is_leadgen: "N",
	is_leadgen_receiver: "N",
	leadgen_field_map: null,
	leadgen_cost: "0.00",
	leadgen_source: null,
	is_order_status: "N",
	is_proposal_admin: "N",
	is_proposal: "N",
	is_webpresentation: "N",
	is_demouser: "N",
	sales_positive_id: "0",
	is_realtime_reporting: "N",
	is_zipmap: "N",
	pto_balance: "0.00",
	is_realtime_report: "N",
	stripe_customer_id: null,
	stripe_card_id: null,
	stripe_plan_id: null,
	stripe_subscription_id: null,
	is_payment_cc: "N",
	is_direct_user: "N",
	quickbooks_id: null,
	is_order_processor: "N",
	quickbooks_is_processed: "N",
	is_network_admin: "N",
	is_audio_user: "N",
	notification_jason_exclusive: "N",
	is_user_login_notification: "Y",
	user_login_webhook_url: null,
	user_login_notify_json_payload: null,
	is_agency_admin: "N",
	is_count_system: "N",
	is_creativebuilder: "N",
	is_whitelabel_reporting_user: "N",
	is_renewal_reporting: "N",
	creativebuilder_uuid: "",
	creativebuilder_apikey: "",
	is_show_eblast_interactions: "N",
	is_eblast_custom_domains: "N",
	is_order_copy: "N",
	is_always_show_reporting: "N",
	is_regenerate_report: "N",
	is_realtime_reporting_admin: "N",
	is_traffic_estimator: "N",
	is_show_dashboard_on_login: "N",
	is_sales_dashboard: "N",
	is_dooh_screen_query: "N",
	is_pd_email_marketing: "N",
	is_hide_order_note_billing_info: "N",
	is_jason_or_mike: "N",
	agencyList: [],
};

const userDataSlice = createSlice({
	name: "userDataSlice",
	initialState,
	reducers: {
		setSessionUser(state, action: PayloadAction<SessionUser>) {
			state.logged = action.payload.logged;
			state.show_promotion_modal = action.payload.show_promotion_modal;
			state.agency_promotion_agency_id = action.payload.agency_promotion_agency_id;
			state.agency_promotion_amount = action.payload.agency_promotion_amount;
			state.agency_promotion_end_date = action.payload.agency_promotion_end_date;
			state.order_search_default = action.payload.order_search_default;
			state.id = action.payload.id;
			state.email = action.payload.email;
			state.username = action.payload.username;
			state.company_name = action.payload.company_name;
			state.first_name = action.payload.first_name;
			state.last_name = action.payload.last_name;
			state.phone = action.payload.phone;
			state.address = action.payload.address;
			state.city = action.payload.city;
			state.campaign_end_default_days = action.payload.campaign_end_default_days;
			state.state = action.payload.state;
			state.postal = action.payload.postal;
			state.status = action.payload.status;
			state.type = action.payload.type;
			state.is_admin = action.payload.is_admin;
			state.is_db_count = action.payload.is_db_count;
			state.is_order_track = action.payload.is_order_track;
			state.is_smallbiz_package = action.payload.is_smallbiz_package;
			state.is_order_create = action.payload.is_order_create;
			state.agency_id = action.payload.agency_id;
			state.is_staff = action.payload.is_staff;
			state.is_reporting = action.payload.is_reporting;
			state.is_openpixel = action.payload.is_openpixel;
			state.is_tester = action.payload.is_tester;
			state.is_support = action.payload.is_support;
			state.is_agent = action.payload.is_agent;
			state.is_agency_files = action.payload.is_agency_files;
			state.is_leadgen = action.payload.is_leadgen;
			state.is_leadgen_receiver = action.payload.is_leadgen_receiver;
			state.leadgen_field_map = action.payload.leadgen_field_map;
			state.leadgen_cost = action.payload.leadgen_cost;
			state.leadgen_source = action.payload.leadgen_source;
			state.is_order_status = action.payload.is_order_status;
			state.is_proposal_admin = action.payload.is_proposal_admin;
			state.is_proposal = action.payload.is_proposal;
			state.is_webpresentation = action.payload.is_webpresentation;
			state.is_demouser = action.payload.is_demouser;
			state.sales_positive_id = action.payload.sales_positive_id;
			state.is_realtime_reporting = action.payload.is_realtime_reporting;
			state.is_zipmap = action.payload.is_zipmap;
			state.pto_balance = action.payload.pto_balance;
			state.is_realtime_report = action.payload.is_realtime_report;
			state.stripe_customer_id = action.payload.stripe_customer_id;
			state.stripe_card_id = action.payload.stripe_card_id;
			state.stripe_plan_id = action.payload.stripe_plan_id;
			state.stripe_subscription_id = action.payload.stripe_subscription_id;
			state.is_payment_cc = action.payload.is_payment_cc;
			state.is_direct_user = action.payload.is_direct_user;
			state.quickbooks_id = action.payload.quickbooks_id;
			state.is_order_processor = action.payload.is_order_processor;
			state.quickbooks_is_processed = action.payload.quickbooks_is_processed;
			state.is_network_admin = action.payload.is_network_admin;
			state.is_audio_user = action.payload.is_audio_user;
			state.notification_jason_exclusive = action.payload.notification_jason_exclusive;
			state.is_user_login_notification = action.payload.is_user_login_notification;
			state.user_login_webhook_url = action.payload.user_login_webhook_url;
			state.user_login_notify_json_payload = action.payload.user_login_notify_json_payload;
			state.is_agency_admin = action.payload.is_agency_admin;
			state.is_count_system = action.payload.is_count_system;
			state.is_creativebuilder = action.payload.is_creativebuilder;
			state.is_whitelabel_reporting_user = action.payload.is_whitelabel_reporting_user;
			state.is_renewal_reporting = action.payload.is_renewal_reporting;
			state.creativebuilder_uuid = action.payload.creativebuilder_uuid;
			state.creativebuilder_apikey = action.payload.creativebuilder_apikey;
			state.is_show_eblast_interactions = action.payload.is_show_eblast_interactions;
			state.is_eblast_custom_domains = action.payload.is_eblast_custom_domains;
			state.is_order_copy = action.payload.is_order_copy;
			state.is_always_show_reporting = action.payload.is_always_show_reporting;
			state.is_regenerate_report = action.payload.is_regenerate_report;
			state.is_realtime_reporting_admin = action.payload.is_realtime_reporting_admin;
			state.is_traffic_estimator = action.payload.is_traffic_estimator;
			state.is_show_dashboard_on_login = action?.payload?.is_show_dashboard_on_login;
			state.is_sales_dashboard = action.payload.is_sales_dashboard;
			state.is_dooh_screen_query = action.payload.is_dooh_screen_query;
			state.is_pd_email_marketing = action.payload.is_pd_email_marketing;
			state.is_hide_order_note_billing_info = action.payload.is_hide_order_note_billing_info ?? "N";
			state.agencyList = action.payload.agencyList; // Store agencyList
		},
		setSessionUserEmail(state, action: PayloadAction<string>) {
			state.email = action.payload;
		},
	},
});

const sessionUserPersistConfig = {
	key: "sessions_user",
	storage,
};

export const userApiSlice = createApi({
	reducerPath: "userApiSlice",
	baseQuery: apiFetchBaseQuery,
	tagTypes: ["userData"],
	endpoints: builder => ({
		getUserData: builder.query<GetMeResponse, undefined>({
			query: () => ({
				url: "auth/me",
			}),
			providesTags: ["userData"],
			keepUnusedDataFor: 0,
		}),
		selectAgency: builder.mutation({
			query: agencyId => ({
				url: `auth/user/agency/${agencyId}`,
				method: "PUT",
			}),
			invalidatesTags: ["userData"],
		}),
	}),
});

export const sessionUserReducer = persistReducer(sessionUserPersistConfig, userDataSlice.reducer);
export const { setSessionUser, setSessionUserEmail } = userDataSlice.actions;
export const defaultSessionUser = Object.freeze(initialState);
export const { useGetUserDataQuery, useLazyGetUserDataQuery, useSelectAgencyMutation } = userApiSlice;
